module.exports = __webpack_public_path__ + "static/media/em-98.77c69c77.png";